/** @format */

import {Box} from '@mui/material';
import {Trans} from 'react-i18next';

import {
  SuccessBody,
  SuccessContent,
  SuccessIconWrapper,
  SuccessTitle,
  SuccessDescription,
  CloseButton,
} from '../../styles';

interface Props {
  onClose: () => void;
}

const SuccessState = ({onClose}: Props) => {
  return (
    <SuccessBody>
      <SuccessContent>
        <SuccessIconWrapper>
          <Box component='span' className='material-symbols-outlined'>
            check_circle
          </Box>
          <SuccessTitle>
            <Trans>Отправлено</Trans>
          </SuccessTitle>
        </SuccessIconWrapper>
        <SuccessDescription>
          <Trans>Спасибо, вы приблизили появление своей системы аналитики в AdSensor</Trans>
        </SuccessDescription>
      </SuccessContent>
      <CloseButton onClick={onClose}>
        <Trans>Закрыть</Trans>
      </CloseButton>
    </SuccessBody>
  );
};

export {SuccessState};
